module.exports = __webpack_public_path__ + "img/icon01.c0e337d3.jpg";